<template>
  <v-container>
    <DataTable
      title="LISTADO DE CITAS VIRTUALES"
      :headers="headers"
      :items="appointmentList"
      :borderRadius="10"
      :loading="loadingTable"
      itemKey="bookingCode"
      :hide-default-footer="false"
      :items-per-page="10"
      :height="300"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import DataTable from '@/infrastructure/vue/components/common/tables/DataTable';
export default {
  name: 'VirtualReservation',
  components: {
    DataTable,
  },
  computed: {
    ...mapGetters('appointment', ['appointmentList']),
    ...mapGetters('login', ['user']),
  },
  data: () => ({
    loadingTable: false,
    headers: [
      { text: 'CODIGO', value: 'bookingCode' },
      { text: 'FECHA DE CITA', value: 'bookingDate' },
      { text: 'HORA DE CITA', value: 'bookingHour' },
      { text: 'DNI', value: 'document' },
      { text: 'CELULAR', value: 'phone' },
      { text: 'CORREO', value: 'mail' },
      { text: 'ESTADO', value: 'statusName' },
      { text: 'MOTIVO', value: 'reasonName' },
    ],
  }),
  methods: {
    handlerFetchAppointment(attentionType) {
      if (attentionType !== null && attentionType !== undefined) {
        this.$store.dispatch(
          'appointment/fetchAppointmentsAction',
          attentionType
        );
      }
    },
  },
  mounted() {
    this.handlerFetchAppointment(this.user.attentionType);
  },
  watch: {
    'user.attentionType': {
      handler(newValue) {
        this.handlerFetchAppointment(newValue);
      },
      deep: true,
    },
  },
};
</script>

<style></style>
